module.exports = __webpack_public_path__ + "static/img/img-card-crm-car-v1.02c9116.png";